module.exports = __webpack_public_path__ + "static/media/platform-icons@3x.a48be67b.png";